import styled from 'styled-components'

type StyledProps = {
  stepPercent: number;
}

const StyledRegistrationLoader = styled.div<StyledProps>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #FCF3E1 2.88%, #E2F3FB 100%);
  outline: none;
  font-family: ${({ theme }) => theme.fonts.lexend};
  z-index: ${({ theme }) => theme.elevations.modal};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  .progress-container {
    display: grid;
    justify-items: center;

    .progress-circle {
      width: 105px;
      height: 105px;
      color: ${({ theme }) => theme.colors.green[300]};
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
  
      .progress-svg {
        width: 105px;
        height: 105px;
        position: absolute;
        border-radius: 50%;
        background-color: ${({ theme }) => theme.colors.background};
        box-shadow: 0px 0px 0px 5px #FFFFFF, 0px 1px 3px 6px rgba(0, 0, 0, 0.08);
  
        .progress-circle-background,
        .progress-circle-progress {
          fill: none;
        }
  
        .progress-circle-background {
          stroke: ${({ theme }) => theme.colors.gray[200]};
        }
  
        .progress-circle-progress {
          stroke: ${({ theme }) => theme.colors.green[300]};
          transition: 1s ease-in-out;
          stroke-dasharray: 596.903;
          stroke-dashoffset: ${({ stepPercent }) => stepPercent};
          stroke-linecap: round;
          stroke-linejoin: round;
        }
      }
  
      .icon {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

        svg {
          height: 60px;
        }
      }
    }
  
    .progress-title {
      margin-top: 40px;
      font-size: 30px;
      color: ${({ theme }) => theme.colors.gray[700]};
    }
  
    .progress-description {
      margin-top: 1rem;
      font-size: 18px;
      color: rgba(0, 0, 0, 0.4);
    }
  }
`

export default StyledRegistrationLoader
